export default () => ({
  items: [],
  query: {
    serialnumber: null,
    referencenumber: null,
    fulltext: null
  },
  searching: false
})
